const RemoveWrapDiv = (props) => props.children;
export default RemoveWrapDiv;